import { render, staticRenderFns } from "./InsKpiCard.vue?vue&type=template&id=60f9c7d0"
import script from "./InsKpiCard.vue?vue&type=script&lang=js"
export * from "./InsKpiCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports